import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/* components */
import Button from 'components/ui/Button/base'
import SectionSubTitle from 'components/ui/SectionSubTitle'

/* styles */
import classes from './index.module.scss'

const TwamMission = () => {
  const { t } = useTranslation('home_volunteering')
  const memoT = useCallback((val) => t(val), [t])

  return (
    <div className={classes.bannerWrapper}>
      <div className={classes.bannerInner}>
        <SectionSubTitle
          item="twamsMissionSectionTitle"
          variant="white"
          spacing="mb-4"
        />
        <div className={classes.bannerText}>
          {memoT('twamMissionHomeDescription')}
        </div>
        <div className={classes.blockWithBtn}>
          <Button
            text="learnMoreLink"
            size="medium"
            onClick={() => window.open('https://www.travelwithamission.org', '_blank')}
          />
        </div>
      </div>
    </div>
  )
}

export default TwamMission
